import { register, find } from '../../../../Javascript/Sysmex/Utils'

const DescriptionTeaser = el => {
  const componentPrefix = el.dataset.componentprefix
  const buttonMore = find(`.${componentPrefix}readMoreBtn`, el)
  const buttonLess = find(`.${componentPrefix}readLessBtn`, el)
  const textTeaser = find(`.${componentPrefix}teaserText`, el)
  const textTeaserTrim = find(`.${componentPrefix}teaserTextTrim`, el)

  if (textTeaser.innerText.length < el.dataset.textlength) {
    return
  }

  buttonMore.classList.add(`${componentPrefix}show`)

  const clickItem = (e) => {
    textTeaser.classList.toggle(`${componentPrefix}hidden`)
    textTeaserTrim.classList.toggle(`${componentPrefix}hidden`)
    buttonMore.classList.toggle(`${componentPrefix}hidden`)
    buttonLess.classList.toggle(`${componentPrefix}hidden`)
  }

  buttonMore.addEventListener('click', clickItem)
  buttonLess.addEventListener('click', clickItem)
}

register('DescriptionTeaser', DescriptionTeaser)
